/**
 * Files Service
 *
 * Service for managing matter-specific files.
 * Provides server actions and client hooks for file operations.
 *
 * Features:
 * - List matter files
 * - Upload new files
 * - Download files
 * - Update file metadata
 * - Delete files
 */

// Types
export * from './types';

// Server actions (uploads + SC reads only — see ./CLAUDE.md)
export {
  getFileAction,
  getPresignedUrlAction,
  getPresignedUrlForNonMatterFileAction,
  uploadCompleteAction,
  uploadUserSignatureAction
} from './actions';

// directApiClient-backed mutations (LF-3217)
export { filesApi } from './client';

// React hooks
export {
  useMatterFiles,
  useFileUpload,
  useFileDownload,
  useMatterFilesService
} from './hooks';

// React Query mutations
export {
  useDeleteFile,
  useUpdateFile,
  useUploadFile,
  useCategoriseFile,
  useAssignIdentityDocument
} from './mutations';

// Utilities
export {
  formatFileSize,
  formatFileType,
  validateFile,
  getFileTypeMetadata
} from './utils';

// Shared file-type descriptor resolver (LF-4642)
export { getFileTypeDescriptor } from './file-type-descriptor';
export type { FileKind, FileTypeDescriptor } from './file-type-descriptor';
